module.exports = __webpack_public_path__ + "img/272I5818.4d52b6f4.jpeg";